import { createApiHooks, schemaToQueryParameters } from '@apis/next/common';
import {
  PreAlertCount,
  PreAlertDetails,
  DashboardPatchPreAlert,
  DashboardPreAlertQuery,
  DashboardPreAlertListItemPages,
  PreAlertQuery,
  PreAlertListItemPages,
} from '@models/next/PreAlert';
import { z } from 'zod';

export const dashboardPreAlertApis = createApiHooks('/dashboard/pre-alert', [
  {
    method: 'get',
    path: '/count',
    parameters: [
      {
        name: 'query',
        schema: DashboardPreAlertQuery,
        type: 'Query',
      },
    ],
    response: PreAlertCount,
  },
  {
    method: 'get',
    path: '',
    parameters: [
      {
        name: 'query',
        schema: DashboardPreAlertQuery,
        type: 'Query',
      },
    ],
    response: DashboardPreAlertListItemPages,
  },
  {
    method: 'get',
    path: '/:d2d_no',
    parameters: [
      {
        name: 'd2d_no',
        schema: z.string(),
        type: 'Path',
      },
    ],
    response: PreAlertDetails,
  },
  {
    method: 'patch',
    path: '/:d2d_no',
    parameters: [
      {
        name: 'd2d_no',
        schema: z.string(),
        type: 'Path',
      },
      {
        name: 'body',
        schema: DashboardPatchPreAlert,
        type: 'Body',
      },
    ],
    response: z.unknown(),
  },
]);

export const preAlertApis = createApiHooks('/pre-alert', [
  {
    method: 'get',
    path: '/:d2d_no',
    parameters: [
      {
        name: 'd2d_no',
        schema: z.string(),
        type: 'Path',
      },
    ],
    response: PreAlertDetails,
  },
  {
    method: 'get',
    path: '/',
    parameters: schemaToQueryParameters(PreAlertQuery),
    response: PreAlertListItemPages,
  },
]);
